/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/01/2024
 */

import * as React from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import Heading from '@/wpt-lib/pdf/common/Heading';
import { Table } from '@/wpt-lib/pdf/common/Table';
import Comments from '@/wpt-lib/pdf/Comments';
import { Comment } from '@/wpt-lib/interfaces/Comment';

const SectionComments = ({ heading, comments }: { heading: string; comments: Comment[] }) => {
    return comments.length > 0 ? (
        <View style={styles.box}>
            <Heading text={heading} level={3} />
            <Table cols={3}>
                <Comments comments={comments} />
            </Table>
        </View>
    ) : null;
};

const styles = StyleSheet.create({
    box: {
        paddingTop: 20,
    },
});

export default SectionComments;
